import { cardTypesConstants } from "../constants/action.constants";
import { cardTypeService } from "../services/cardtypes.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const cardTypeActions = {
  addCardType,
  getAllCardTypes,
  getCardType,
  resetCardType,
  resetAddCardType
};

function getAllCardTypes() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await cardTypeService.getAllCardTypes();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CARD_TYPES
        )
      );
    }
  };

  function request() {
    return { type: cardTypesConstants.GET_CARDTYPES_REQUEST };
  }
  function success(response) {
    return { type: cardTypesConstants.GET_CARDTYPES_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardTypesConstants.GET_CARDTYPES_FAILURE, error };
  }
}

function getCardType(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await cardTypeService.getCardType(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_CARD_TYPE}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: cardTypesConstants.VIEW_CARDTYPE_REQUEST, id };
  }
  function success(response) {
    return { type: cardTypesConstants.VIEW_CARDTYPE_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardTypesConstants.VIEW_CARDTYPE_FAILURE, error };
  }
}

function addCardType(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await cardTypeService.addCardType(requestBody);
      response && dispatch(success(response));
      dispatch(getAllCardTypes());
      if (requestBody.id) {
        history.push(routeConstants.CARDTYPES.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_CARD_TYPE : message.ADD_CARD_TYPE
        )
      );
      dispatch(resetAddCardType());
      dispatch(resetCardType());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_CARD_TYPE : message.ADD_CARD_TYPE
        )
      );
    }
  };

  function request(requestBody) {
    return { type: cardTypesConstants.ADD_CARDTYPE_REQUEST, requestBody };
  }
  function success(response) {
    return { type: cardTypesConstants.ADD_CARDTYPE_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardTypesConstants.ADD_CARDTYPE_FAILURE, error };
  }
}

function resetCardType() {
  return { type: cardTypesConstants.VIEW_CARDTYPE_RESET };
}

function resetAddCardType() {
  return { type: cardTypesConstants.ADD_CARDTYPE_RESET };
}
